export const config = {
    perPage: 5,
    preloadThreshold: 3,
    similarImagesCount: 6,
    categoryToIds: {
        "animals": [237, 433, 582, 593, 659, 783, 837, 1024, 1025, 1074, 1084],
        "nature": [10, 15, 27, 28, 29, 49, 65, 111, 133, 149, 192, 193, 197],
        "architecture": [36, 101, 142, 164, 172, 186, 238, 318, 429, 452, 469],
        "people": [26, 64, 91, 129, 169, 338, 453, 497, 505, 628, 660],
        "tech": [0, 2, 7, 60, 180, 331, 370, 383, 385, 494, 532],
        "dog": [237, 1025, 1062, 169, 1074, 200, 250, 659, 837, 1084],
        "city": [164, 320, 401, 429, 452, 1015, 599, 582, 535, 488],
        "food": [102, 292, 431, 488, 633, 755, 824, 835, 844, 867]
    }
};
